import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./Non_Work_Form.css";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import {
  Create,
  GetAll,
} from "../../../../../../../../src/features/admin/quality_management/process_requirement/non_confirming_work/Slice";
import { allDepartment } from "../../../../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";

function Non_Work_Form({ handleClose }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    watch,
    control,
  } = useForm();

  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const [filePreview, setFilePreview] = useState(null);
  const [success, setSuccess] = useState(false);

  const all_department = useSelector((state) => state.common.all_department);

  useEffect(() => {
    dispatch(allDepartment());
  }, [dispatch]);

  // ⏱ auto hide success toaster
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  // ✅ SUBMIT
  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      formData.append("record_no", data.record_no);
      formData.append("date_raised", data.date_raised);
      formData.append("department_id", data.department_id);
      formData.append(
        "non_conformity_statement",
        data.non_conformity_statement,
      );
      formData.append("clause", data.clause);
      formData.append("initial_action_taken", data.initial_action_taken);
      formData.append("root_cause_analysis", data.root_cause_analysis);
      formData.append(
        "corrective_action_proposed",
        data.corrective_action_proposed,
      );
      formData.append("responsibility", data.responsibility);
      formData.append("target_date", data.target_date);
      formData.append("remark", data.remark || "");

      // if (data.attach_file instanceof File) {
      formData.append("attach_file", data.image[0]);
      // }

      const res = await dispatch(Create(formData));

      if (res.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        reset();
        setFilePreview(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
        setSuccess(true);
        handleClose?.();
      }
    } catch (err) {
      console.error("Submit error:", err);
    }
  };

  // ✅ FILE HANDLER
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setValue("attach_file", file, { shouldValidate: true });
      setFilePreview(URL.createObjectURL(file));
    }
  };

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            {/* Record No */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Record No.</Form.Label>
                <Form.Control
                  placeholder="NCR [Year]/[Sequential Number]"
                  {...register("record_no", {
                    required: "Record No is required",
                  })}
                />
                {errors.record_no && (
                  <Form.Text className="text-danger">
                    {errors.record_no.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Date Raised */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Date Raised</Form.Label>
                <Form.Control
                  type="date"
                  {...register("date_raised", {
                    required: "Date Raised is required",
                    // validate: (value) => {
                    //   const year = value.split("-")[0];

                    //   if (year.length !== 4) {
                    //     return "Year must be exactly 4 digits";
                    //   }

                    //   const selectedDate = new Date(value);
                    //   const today = new Date();
                    //   today.setHours(0, 0, 0, 0);

                    //   if (selectedDate < today) {
                    //     return "Past dates are not allowed";
                    //   }

                    //   return true;
                    // },
                  })}
                  onChange={(e) => {
                    let value = e.target.value;
                    const parts = value.split("-");

                    if (parts[0] && parts[0].length > 4) {
                      parts[0] = parts[0].slice(0, 4);
                      e.target.value = parts.join("-");
                    }
                  }}
                />
                {errors.date_raised && (
                  <Form.Text className="text-danger">
                    {errors.date_raised.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Department */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Dept./Area</Form.Label>
                <Controller
                  name="department_id"
                  control={control}
                  rules={{ required: "Department is required" }}
                  render={({ field }) => (
                    <Select
                      options={all_department}
                      value={
                        all_department?.find((o) => o.value === field.value) ||
                        null
                      }
                      onChange={(e) => field.onChange(e?.value || null)}
                    />
                  )}
                />
                {errors.department_id && (
                  <Form.Text className="text-danger">
                    {errors.department_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Non Conformity */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Non-Conformity Statement</Form.Label>
                <Form.Control
                  {...register("non_conformity_statement", {
                    required: "Statement is required",
                  })}
                />
                {errors.non_conformity_statement && (
                  <Form.Text className="text-danger">
                    {errors.non_conformity_statement.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Clause */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Clause / Document Violated</Form.Label>
                <Form.Control
                  {...register("clause", {
                    required: "Clause is required",
                  })}
                />
                {errors.clause && (
                  <Form.Text className="text-danger">
                    {errors.clause.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Initial Action */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Initial Action Taken</Form.Label>
                <Form.Control
                  {...register("initial_action_taken", {
                    required: "Initial Action is required",
                  })}
                />
                {errors.initial_action_taken && (
                  <Form.Text className="text-danger">
                    {errors.initial_action_taken.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Root Cause */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Root Cause Analysis</Form.Label>
                <Form.Control
                  {...register("root_cause_analysis", {
                    required: "Root Cause Analysis is required",
                  })}
                />
                {errors.root_cause_analysis && (
                  <Form.Text className="text-danger">
                    {errors.root_cause_analysis.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Corrective Action */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Corrective Action Proposed</Form.Label>
                <Form.Control
                  {...register("corrective_action_proposed", {
                    required: "Corrective Action is required",
                  })}
                />
                {errors.corrective_action_proposed && (
                  <Form.Text className="text-danger">
                    {errors.corrective_action_proposed.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Responsibility */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Responsibility</Form.Label>
                <Form.Control
                  {...register("responsibility", {
                    required: "Responsibility is required",
                  })}
                />
                {errors.responsibility && (
                  <Form.Text className="text-danger">
                    {errors.responsibility.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Target Date */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Target Date</Form.Label>
                <Form.Control
                  type="date"
                  {...register("target_date", {
                    required: "Target Date is required",
                  })}
                  onChange={(e) => {
                    let value = e.target.value;
                    const parts = value.split("-");

                    if (parts[0] && parts[0].length > 4) {
                      parts[0] = parts[0].slice(0, 4);
                      e.target.value = parts.join("-");
                    }
                  }}
                />
                {errors.target_date && (
                  <Form.Text className="text-danger">
                    {errors.target_date.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Remark</Form.Label>
                <Form.Control
                  {...register("remark", {
                    required: "Remark is required",
                  })}
                />
                {errors.remark && (
                  <Form.Text className="text-danger">
                    {errors.remark.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {/* Attach File */}
            <div className="col-md-4">
              <Form.Group className="form_group file_field">
                <Form.Label>Attached File (Optional)</Form.Label>

                <div className="absolute_fields">
                  <Form.Control
                    type="file"
                    {...register("image", {
                      // required:
                      //   typeof getValues("image") === "string"
                      //     ? false
                      //     : "File is required",
                    })}
                    accept="*"
                  />
                  <div className="upload_icon_holder">
                    <FontAwesomeIcon icon={faUpload} />
                  </div>
                  {errors.image && (
                    <span className="text-danger">{errors.image.message}</span>
                  )}
                </div>
                {(() => {
                  const fileValue = watch("image");

                  // URL for preview
                  const fileUrl =
                    typeof fileValue === "string"
                      ? process.env.REACT_APP_IMG_URL + fileValue
                      : fileValue?.length > 0
                      ? URL.createObjectURL(fileValue[0])
                      : null;

                  // Type detection
                  const fileType =
                    typeof fileValue === "string"
                      ? fileValue.toLowerCase()
                      : fileValue?.[0]?.type;

                  if (!fileUrl) return null;

                  return (
                    <div className="image_holder">
                      {/* IMAGE */}
                      {(fileType?.includes("image") ||
                        fileType?.endsWith(".jpg") ||
                        fileType?.endsWith(".jpeg") ||
                        fileType?.endsWith(".png")) && (
                        <img
                          src={fileUrl}
                          alt="Preview"
                          className="image-preview"
                          // style={{ maxWidth: "100px" }}
                        />
                      )}

                      {/* PDF */}
                      {(fileType === "application/pdf" ||
                        fileType?.endsWith(".pdf")) && (
                        <iframe
                          src={fileUrl}
                          // style={{ maxWidth: "100px" }}
                          title="PDF"
                        />
                      )}

                      {/* WORD */}
                      {(fileType?.includes("word") ||
                        fileType?.endsWith(".doc") ||
                        fileType?.endsWith(".docx")) && (
                        <div>
                          <p>Word preview not supported</p>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open / Download Word File
                          </a>

                          <iframe
                            src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                            style={{ maxWidth: "100px" }}
                            title="Word Preview"
                          />
                        </div>
                      )}

                      {/* EXCEL */}
                      {(fileType?.includes("spreadsheet") ||
                        fileType?.endsWith(".xlsx") ||
                        fileType?.endsWith(".xls")) && (
                        <div>
                          <p>Excel preview not supported</p>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open / Download Excel File
                          </a>
                        </div>
                      )}
                    </div>
                  );
                })()}
                {/* {filePreview && (
                  <div className="image_holder">
                    <img
                      src={filePreview}
                      alt="Preview"
                      className="img_preview"
                    />
                  </div>
                )} */}
              </Form.Group>
            </div>
          </div>

          {/* Buttons */}
          <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Saved Successfully!" />
            ) : (
              <>
                <Button
                  type="button"
                  className="permission_btn No_btn"
                  onClick={handleClose}
                >
                  Reset
                </Button>

                <Button type="submit" className="permission_btn Yes_btn">
                  Save
                </Button>
              </>
            )}
          </div>
        </form>
      </div>
    </section>
  );
}

export default Non_Work_Form;
